import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared';
import { PedidoFracionadoBadgeComponent } from './pedido-fracionado-badge.component';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        PedidoFracionadoBadgeComponent
    ],
    exports: [
        PedidoFracionadoBadgeComponent
    ]
})
export class PedidoFracionadoBadgeModule { }
